import { ResolveFn } from '@angular/router';
import { UserModel } from '../../core/models/user.model';
import { AuthService } from '../../core/services/auth.service';
import { inject } from '@angular/core';

export const dbUserResolver: ResolveFn<UserModel | null> = () => {
  const authService = inject(AuthService);

  return authService.dbUser$;
};
